<template>
  <div class="img" style="width: 300px;">
    <a-upload
      ref="aupload"
      name="file"
      listType="picture-card"
      :multiple="isMultiple"
      :action="uploadAction"
      :headers="headers"
      :data="{biz:bizPath}"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      :disabled="disabled"
      :isMultiple="isMultiple"
      :showUploadList="isMultiple"
      @change="handleChange"
      @preview="handlePreview"
      :class="!isMultiple?'imgupload':''">
      <div :style="{'width':(width>0?(width+'px'):'auto'),'height':(height>0?(height+'px'):'auto')}">

          <img v-if="!isMultiple && picUrl " v-show="imgLoading"  :src="getAvatarView()"  style="width:100%;height:100%"/>

        <div v-else :class="{'iconp':width>0}" >
          <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">{{ text }}</div>
        </div>
        <div v-if="!isMultiple && picUrl && !imgLoading" :class="{'iconp':width>0}" >
          <a-icon :type="'loading'" />
          <div class="ant-upload-text">图片加载中</div>
        </div>
      </div>
      <div style="margin-left: 320px;margin-top:-188px;position: absolute" v-if="!isMultiple && picUrl">
        <div>
          <a-button  @click.stop="handlePreviewBtn" style="font-size: 16px">查看原图</a-button>
        </div>
        <div style="margin-top: 10px;" v-if="!disabled">
          <a-button  @click.stop="deletePic" style="font-size: 16px">删除照片</a-button>
        </div>
        <div style="margin-top: 10px;" v-if="scan&& picUrl">
          <a-button  @click.stop="scanPic" :loading="scanFlag" style="font-size: 16px">识别填充</a-button>
        </div>
      </div>




    </a-upload>
    <!--<a-modal :visible="previewVisible" :wrapClassName="'ant-modal-wrap'+tranfrom" :mask="false" :maskClosable="false" :footer="null" @cancel="handleCancel()">-->
      <!--<img alt="example" style="width: 100%" :src="previewImage" @click="toTranfrom"/>-->
    <!--</a-modal>-->

      <!--<div v-show="previewVisible" style="position: fixed;-->
    <!--top: 20%;-->
    <!--left: 20%;-->
    <!--z-index: 100;-->
    <!--width: 40%;-->
    <!--height: 500px;background: #ccc;padding: 10px;overflow-y: scroll">-->

        <!--<div  :class="'ant-modal-wrap'+tranfrom" >-->
          <!--<img alt="example" style="width: 100%" :src="previewImage" @click="toTranfrom"/>-->
        <!--</div>-->
        <!--<a-icon type="close" style="position: fixed;-->
    <!--left: 59%;-->
    <!--z-index: 999;-->
    <!--top: 20%;-->
    <!--font-size: 20px;-->
    <!--line-height: 20px;cursor: pointer" @click="handleCancel"></a-icon>-->
      <!--</div>-->
    <div ref="viewer" class="images" v-viewer="viewerOptions" style="display: none;">
      <img :src="previewImage" :key="previewImage">
    </div>


  </div>


</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getFileAccessHttpUrl,getAction } from '@/api/manage'
import { getAccessToken } from '@/utils/token'

  const uidGenerator=()=>{
    return '-'+parseInt(Math.random()*10000+1,10);
  }
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'JImageUpload',
    data(){
      return {
        uploadAction:window._CONFIG['domianURL']+"/sys/common/upload",
        uploadLoading:false,
        picUrl:false,
        headers:{},
        fileList: [],
        previewImage:"",
        previewVisible: false,
        scanFlag:false,
        tranfrom:1,
        urlList:[],
        viewerOptions:{
          title: false, // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
          toolbar: true, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
          movable: true, // 图片是否可移动[布尔值：默认true]
          zoomable: true, // 图片是否可缩放[布尔值：默认true]
          url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
        },
        imgLoading:false
      }
    },
    props:{
      text:{
        type:String,
        required:false,
        default:"上传"
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },
      value:{
        type:[String,Array],
        required:false
      },
      disabled:{
        type:Boolean,
        required:false,
        default: false
      },
      isMultiple:{
        type:Boolean,
        required:false,
        default: false
      },
      //update-begin-author:wangshuai date:20201021 for:LOWCOD-969 新增number属性，用于判断上传数量
      number:{
        type:Number,
        required:false,
        default:0
      },
      width:{
        type:Number,
        required:false,
        default:104
      },
      height:{
        type:Number,
        required:false,
        default:50
      },scan:{
        type:String,
        required:false,
        default: ''
      }
      //update-end-author:wangshuai date:20201021 for:LOWCOD-969 新增number属性，用于判断上传数量
    },
    watch:{
      value: {
        handler(val,oldValue) {
          if (val instanceof Array) {
            this.initFileList(val.join(','))
          } else {
            this.initFileList(val)
          }
          if(!val || val.length==0){
            this.picUrl = false;
          }
        },
        //立刻执行handler
        immediate: true
      }
    },
    created(){
      const token = getAccessToken();
      this.headers = {"X-Access-Token":token}
    },
    methods:{
      initFileList(paths) {
        if (!paths || paths.length == 0) {
          this.fileList = [];
          return;
        }
        this.picUrl = true;
        let fileList = [];
        let arr = paths.split(",")
        for (var a = 0; a < arr.length; a++) {
          let url = getFileAccessHttpUrl(arr[a]);
          fileList.push({
            uid: uidGenerator(),
            name: getFileName(arr[a]),
            status: 'done',
            url: url,
            response: {
              status: "history",
              message: arr[a]
            }
          })
        }
        this.fileList = fileList

      },
      beforeUpload: function(file){
        var fileType = file.type;
        console.log("上传文件",fileType)

        if(fileType.indexOf('image')<0 ){
          this.$message.warning('请上传图片');
          return false;
        }
        this.callbackImgState(1);
      },
      handleChange(info) {
        console.log(info)
        this.picUrl = false;
        let fileList = info.fileList
        //update-begin-author:wangshuai date:20201022 for:LOWCOD-969 判断number是否大于0和是否多选，返回选定的元素。
        if(this.number>0 && this.isMultiple){
          fileList = fileList.slice(-this.number);
        }
        //update-end-author:wangshuai date:20201022 for:LOWCOD-969 判断number是否大于0和是否多选，返回选定的元素。
        if(info.file.status==='done'){
          if(info.file.response.success){
            this.picUrl = true;
            fileList = fileList.map((file) => {
              if (file.response) {
                file.url = file.response.message;
              }
              return file;
            });
          }

          this.callbackImgState(-1);
          //this.$message.success(`${info.file.name} 上传成功!`);
        }else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
          this.callbackImgState();
        }else if(info.file.status === 'removed'){
          this.handleDelete(info.file)
        }
        this.fileList = fileList
        if(info.file.status==='done' || info.file.status === 'removed'){
          this.handlePathChange(-1)
        }
      },
      // 预览
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
        this.$refs.viewer.$viewer.show();
      },
      // 预览
      handlePreviewBtn () {
        let file = this.fileList[0]
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
        this.$refs.viewer.$viewer.show();
      },deletePic(){
        let file = this.fileList[0]
        file.status = 'removed';
        let info ={
          file:file
        }
        this.handleChange(info);
      },
      getAvatarView(){
        if(this.fileList.length>0){
          let url = this.fileList[0].url

          if(!url.indexOf("http")!=-1){
           url = getFileAccessHttpUrl(url);
          }
          let img = new Image();
          img.src = url;
          let taht = this;
          img.onload = function(){
              taht.imgLoading = true
          }
          return url;
        }
      },
      handlePathChange(){
        let uploadFiles = this.fileList
        let path = ''
        if(!uploadFiles || uploadFiles.length==0){
          path = ''
        }
        let arr = [];
        if(uploadFiles){
          if(!this.isMultiple){
            if(uploadFiles[uploadFiles.length-1].status!="removed"){
              arr.push(uploadFiles[uploadFiles.length-1].response.message)
            }
          }else{
            for(let a=0;a<uploadFiles.length;a++){
              // update-begin-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
              if(uploadFiles[a].status === 'done' ) {
                arr.push(uploadFiles[a].response.message)
              }else{
                return;
              }
              // update-end-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
            }
          }
        }

        if(arr.length>0){
          path = arr.join(",")
        }
        this.$emit('change', path);
      },
      handleDelete(file){
        //如有需要新增 删除逻辑
        console.log(file)
      },
      handleCancel() {
        this.close();
        this.previewVisible = false;
      },
      close () {
        console.log( this.fileList)
      },scanPic(){
        let that = this;
        that.scanFlag = true;
        if( this.fileList &&  this.fileList.length){
          let path =  this.fileList[0].response.message;
          getAction("/dm/baiDuOcr/getOcrInfo",{"imgPath":path,"type":this.scan}).then((res)=>{
            if(res.success){
              this.$message.success("识别成功");
              that.$emit("scanOk",res.result);
              //that.scanFlag = false;
            }else{
              this.$message.warning("识别失败");
            }
          }).finally(() => {
            that.scanFlag = false;
          })
        }

      },callbackImgState(num){

        this.$emit("getImgState",num);
      },toTranfrom(){
        if(this.tranfrom>=4){
          this.tranfrom = 1;
        }else{
          this.tranfrom++;
        }
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
  /* update--begin--autor:lvdandan-----date:20201016------for：j-image-upload图片组件单张图片详情回显空白
  * https://github.com/zhangdaiscott/jeecg-boot/issues/1810
  * https://github.com/zhangdaiscott/jeecg-boot/issues/1779
  */
  /deep/ .imgupload .ant-upload-select{display:block}
  /deep/ .imgupload .ant-upload.ant-upload-select-picture-card{ width:120px;height: 120px;}
  /deep/ .imgupload .iconp{padding:32px;}
  /deep/ .ant-modal-wrap1{
    left: -30%;
  }
  /deep/ .ant-modal-wrap2{
    left: -30%;
    transform: rotate(90deg);
  }
  /deep/ .ant-modal-wrap3{
    left: -30%;
    transform: rotate(180deg);
  }
  /deep/ .ant-modal-wrap4{
    left: -30%;
    transform: rotate(270deg);
  }





  /* update--end--autor:lvdandan-----date:20201016------for：j-image-upload图片组件单张图片详情回显空白*/
</style>

